import { EnderecoModel } from './../endereco/endereco.model';
import { CentroCustoModel } from './centrocusto.model';
import { ClienteModel } from './cliente.model';
import { UnidadeGestoraModel } from './unidadegestora';


export class AreaModel {
    id: number;
    codigo: number;
    descricao: String;
    observacao: String;
    tipoCadastroArea: String;
    areaPadrao: boolean;
    ativo: boolean;
    codAutomatico: boolean;
    dataDesativacao: Date;
    centroCusto: CentroCustoModel;
    endereco: EnderecoModel;
    cliente: ClienteModel;
    unidadeGestora: UnidadeGestoraModel;
    sigla: String;
    usuarios: any[];
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/area.model.ts